import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Spinner } from '@pearsontechnology/aero-components';
import useStudentGradeSummary from './useStudentGradeSummary';
import { Menu } from './components';
import GradableComponentRow from './GradableComponentRow';

const InteractiveGradesMenu = ({ studentId, cohortId, deploymentId, walkableType, walkableId }) => {
  const { loading, data } = useStudentGradeSummary({
    cohortId,
    deploymentId,
    walkableType,
    walkableId,
  });

  if (!studentId) {
    return (<div></div>);
  }

  return (
    <Fragment>
      {loading ? (
        <Spinner small style={{ margin: '1em auto' }} />
      ) : (
        <Menu>
          {data.map((item) => (
            <GradableComponentRow
              key={item.componentId}
              cohortId={cohortId}
              deploymentId={deploymentId}
              studentId={studentId}
              componentId={item.componentId}
              interactiveId={item.parentId}
              title={item.componentConfiguration.title}
              maxScore={item.maxScore}
            />
          ))}
        </Menu>
      )}
    </Fragment>
  );
};

InteractiveGradesMenu.propTypes = {
  studentId: PropTypes.string,
  cohortId: PropTypes.string,
  deploymentId: PropTypes.string,
  walkableType: PropTypes.string,
  walkableId: PropTypes.string,
};

export default InteractiveGradesMenu;
